import { getEnvSetting } from "./env";
import { queryStringToFilters, filterToQueryString } from "./filters";

export const getPdfLink = queryStr => {
  const filters = { ...queryStringToFilters(queryStr), format: "pdf" };
  const query = filterToQueryString(filters);
  return getEnvSetting("REACT_APP_API_URL") + "/entries?format=pdf&" + query;
};

export default response => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const error = new Error();
  error.response = response;
  throw error;
};



/** WEBPACK FOOTER **
 ** ./src/utils/api.js
 **/